module.exports = __webpack_public_path__ + "static/media/ExoBNNVARA-Black.025536b5.woff";